import { z } from 'zod';

import { RunSchema } from '@/types/schema';
import { useLocalStorageState } from '@/utils/use-local-storage-state';

export function useUserPrefs({
  comparePosition,
  searchFilter,
  filteredRuns,
}: {
  searchFilter: string | undefined;
  filteredRuns: RunSchema[] | undefined;
  comparePosition?: 'left' | 'right';
}) {
  const [userAllRuns, setUserAllRuns] = useLocalStorageState(
    `ls:runDetails:showAll${comparePosition ? `:${comparePosition}` : ''}`,
    false,
    z.boolean()
  );

  const [userFilteredOnly, setUserFilteredOnly] = useLocalStorageState(
    `ls:runDetails:filteredOnly${comparePosition ? `:${comparePosition}` : ''}`,
    true,
    z.boolean()
  );

  const [showGraphStats, setShowGraphStats] = useLocalStorageState(
    `ls:runDetails:showGraphStats${
      comparePosition ? `:${comparePosition}` : ''
    }`,
    false,
    z.boolean()
  );

  const filteredOnly = userFilteredOnly && !!searchFilter;
  const filterCount = filteredRuns?.length ?? 0;

  return {
    filteredOnly,
    filterCount,
    userAllRuns,
    setUserAllRuns,
    userFilteredOnly,
    setUserFilteredOnly,
    showGraphStats,
    setShowGraphStats,
  };
}
